import { render, staticRenderFns } from "./StudyAbroadJourney.vue?vue&type=template&id=07dc7ec5&"
import script from "./StudyAbroadJourney.vue?vue&type=script&lang=js&"
export * from "./StudyAbroadJourney.vue?vue&type=script&lang=js&"
import style0 from "./StudyAbroadJourney.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports